module.exports = __webpack_public_path__ + "img/oldman.8890af57.png";